import { useDropzone } from "react-dropzone";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import "./File.scss";
import FontAwesomeIcon from "../Icon";
import Button from "../Button";

const Attachment = ({
  onSelect,
  files,
  clearFiles,
  icon,
  isMultiple,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: `image/*,application/pdf`,
    multiple: isMultiple ? true : false,
    onDrop: (acceptedFiles) => {
      let imageSelected = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      onSelect(imageSelected);
    },
  });

  return (
    <div>
      <div
        className={classNames("file", {
          "file--active": isDragActive,
        })}
      >
        <div {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} className="file__control" />
          <>
            {icon ? (
              <FontAwesomeIcon glyph="paperclip" weight="light" size="small" />
            ) : (
              <h4>Add Attachment</h4>
            )}
          </>
        </div>
      </div>
      <div className="name">
        {files.length > 0 ? (
          <>
            {" "}
            {files[0].name} {"  "}
            <Button
              color="semantic"
              label={<FontAwesomeIcon glyph="trash" weight="light" />}
              onClick={() => {
                clearFiles();
              }}
            />{" "}
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Attachment;
